import React, { useRef, useState } from "react";
import { useFrame } from "@react-three/fiber";
import { useGLTF } from '@react-three/drei'
import * as THREE from 'three'

const GltfModel = ({ modelPath, scale = 40, position = [0, 0, 0], children }) => {
  const ref = useRef();
  const gltf = useGLTF(modelPath)
  const [hovered, hover] = useState(false);
  return (
    <>
      <primitive
        ref={ref}
        object={gltf.scene}
        position={position}
        scale={scale}
        onPointerOver={(event) => hover(true)}
        onPointerOut={(event) => hover(false)}
        side={THREE.DoubleSide} 
      >
        {children}
       </primitive> 
    </>
  );
};

export default GltfModel;